import React from 'react';
import { Link } from 'react-router-dom';
import './PricingSection.css';

const PricingSection = () => {
    // Pricing plans data
    const plans = [
        {
            id: 1,
            name: 'عرض الحصري',
            price: '2500',
            unit: 'جنيه / متر',
            description: 'تشطيب مميز بخامات عالية الجودة وضمان مدى الحياة بأسعار تنافسية',
            features: [
                'سلك سويدي معتمد (1.5 ملي – 2 ملي – 3 ملي – 4 ملي)',
                'سباكة الشريف أو BR ماركة معتمدة (التوصيل يتم رفعه مع شهادة ضمان)',
                'عزل أرضيات الحمامات بضمان مدى الحياة',
                'مادة الأساس بطبقة أسمنتية مع شهادة ضمان',
                'ديكورات فوم إيطالي لجميع الديكورات',
                'ترميم محارة (الخدمة خاصة بالكهرباء والخارج للإضاءة فقط)',
                'تصميم وتنفيذ سقف جبس عادي حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس أو جوتن أو بايت أو GLC) حسب اختيار العميل للون',
                'ساسية مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمركت 1.6 و4 ملي بالسمنت والطريقة',
                'بيت BS مفصول عن الشقة (قطعة BS ستارة ومفتاح) حسب الدور والارتفاع واختيار اللون المناسب',
                'بيت نيش فايبر حسب اختيار العميل للشكل',
                'دهانات بيت فايبر حسب اختيار العميل للشكل',
                'عرض شامل كامل للغرف والريسبشن'
            ],
            recommended: false,
            color: '#e67e22'
        }, // 2500
        {
            id: 2,
            name: 'عرض المناسب',
            price: '3000',
            unit: 'جنيه / متر',
            description: 'عرض مميز لتشطيب السقف الجبسي والإضاءة بتفاصيل عالية الجودة وضمان مدى الحياة',
            features: [
                'سلك سويدي معتمد (1.5 ملي – 3 ملي – 4 ملي)',
                'مفاتيح كهرباء بساس أو فينوس أو لوجي بضمان مدى الحياة',
                'سلك التليفزيون والريسيفر BR معتمد مع شهادة ضمان',
                'أنظمة إضاءة مضمونة مدى الحياة',
                'مادة الأساس بطبقة أسمنتية مع شهادة ضمان',
                'ديكورات فوم إيطالي لجميع الأشكال',
                'سبوتات إضاءة (اللمبات خاصة بالعميل)',
                'تصميم وتنفيذ سقف معلق ثلاثي الأبعاد حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس أو جوتن أو بايت أو GLC) حسب اختيار العميل',
                'ساسية مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمركت (1.6 – 4 – 6 ملي) بالسمنت والطريقة',
                'بيت BS مفصول عن الشقة مع ستارة ومفتاح حسب التصميم',
                'بيت نيش فايبر حسب اختيار العميل للشكل',
                'بيت مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)'
            ],
            recommended: false,
            color: '#3498db'
        }, // 3000
        {
            id: 3,
            name: 'عرض المميز',
            price: '3500',
            unit: 'جنيه / متر',
            description: 'تشطيب مميز بخامات فاخرة وتفاصيل دقيقة وضمان مدى الحياة في جميع الأعمال',
            features: [
                'سلك سويدي معتمد (1.5 ملي – 3 ملي – 4 ملي)',
                'مفاتيح كهرباء بساس أو فينوس أو لوجي بضمان مدى الحياة',
                'سلك التليفزيون أو BR ماركة معتمدة مع شهادة ضمان',
                'عزل أرضيات الحمامات بضمان مدى الحياة (عزل مادة البيتومين + طبقة أسمنتية + شهادة ضمان)',
                'ديكورات فوم إيطالي لجميع الديكورات',
                'ترميم محارة (الخدمة الخاصة بالكهرباء والخارج للإضاءة فقط)',
                'تصميم وتنفيذ سقف معلق ثلاثي الأبعاد حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس أو جوتن أو بايت أو GLC) حسب اختيار العميل للون',
                'ساسية مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمركت 1.6 و4 ملي بالسمنت والطريقة',
                'بيت BS مفصول عن الشقة (قطعة BS ستارة ومفتاح) حسب الدور والارتفاع واختيار اللون المناسب',
                'بيت نيش فايبر حسب اختيار العميل للشكل',
                'دهانات بيت فايبر حسب اختيار العميل للشكل',
                'بيت مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)',
                'توريد وتركيب طقم حمام (ديورافيت أو إيديال ستاندرد أو تركي معتمد)',
                'خلاطات حمام ومطبخ من نوع (ديورافيت أو إيديال ستاندرد أو كلودي) بضمان مدى الحياة',
                'دهانات فاخرة بجميع الألوان حسب اختيار العميل'
            ],

            recommended: true,
            color: '#1abc9c'
        }, // 3500
        {
            id: 4,
            name: 'عرض الفاخر',
            price: '4200',
            unit: 'جنيه / متر',
            description: 'تشطيب فاخر بخامات عالية الجودة وتفاصيل دقيقة مع ضمان مدى الحياة في معظم البنود',
            features: [
                'سلك سويدي معتمد (0.5 ملم – 1 ملم – 2 ملم – 4 ملم)',
                'مفاتيح كهرباء سانشي أو فابريس أو فينوس بضمان مدى الحياة',
                'سلك أو شريط BR أو ماركة معتمدة مع شهادة ضمان',
                'عزل أرضيات الحمامات ضمان مدى الحياة (عزل مادة البيتومين + طبقة أسمنتية + شهادة ضمان)',
                'ديكورات فوم فاناتر لجميع الديكورات',
                'ترميم محارة (الخدمة الخاصة بالكهرباء والداخلي للإضاءة فقط)',
                'تصميم مركز إنارة خاص للعميل يشمل كرت إنارة 4 هام ورباعي',
                'تصميم سقف معلق ثلاثي الأبعاد (سيستم + جبس + بليت + ليزر) حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس – جوتن – بايت – GLC) حسب اختيار العميل للون',
                'ساسية معجون مميزة (لون – سعر – تربة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمرة 1.6 ملم و4 ملم للسمنتج والطريقة',
                'كريستال BS (بيت النور الرئيسي والفرعي مع ستارة ومفتاح) حسب الدور والارتفاع واللون المناسب',
                'نيشة فايبر حسب اختيار العميل للشكل',
                'بيت فايبر مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)',
                'طقم حمام كامل (قاعدة – مرحاض – بانيو – أحواض) من ديورافيت أو إيديال ستاندرد أو تيرو الإيطالي',
                'خلاطات حمام ومطبخ (كلودي – إيديال – مخلوط من النادي) بضمان مدى الحياة',
                'دهانات فاخرة بجميع الألوان حسب اختيار العميل',
                'عزل صوت التكييف حسب الكتالوج والفرز المطلوب'
            ],
            recommended: false,
            color: '#1abc9c'
        }, //4200
        {
            id: 5,
            name: 'عرض الفخامة',
            price: '5000',
            unit: 'جنيه / متر',
            description: 'تشطيب فخم بخامات عالية الجودة وتفاصيل دقيقة وضمانات ممتدة لمعظم البنود',
            features: [
                'سلك سويدي معتمد (0.5 ملم – 1 ملم – 2 ملم – 3 ملم – 4 ملم)',
                'مفاتيح كهرباء سانشي أو فابريس أو لوجي بضمان مدى الحياة',
                'سلك تليفزيون BR أو ماركة معتمدة مع شهادة ضمان',
                'عزل أرضيات الحمامات بضمان مدى الحياة (عزل مادة البيتومين + طبقة أسمنتية + شهادة ضمان)',
                'ديكورات فوم فاناتر لجميع الديكورات',
                'ترميم محارة (الخدمة الخاصة بالكهرباء والخارج للإضاءة فقط)',
                'تصميم مركز إنارة خاص للعميل يشمل كرت إنارة 4 هام ورباعي',
                'تصميم سقف معلق ثلاثي الأبعاد (سيستم – جبس – بليت – ليزر) حسب اختيار العميل للشكل',
                'دهانات نهائية (ساس – جوتن – بايت – GLC) حسب اختيار العميل للون',
                'ساسية معجون مميزة (لون – سعر – صنفرة – بطانة – شحن) حسب اختيار العميل',
                'أسلاك الكهرباء الرئيسية سويدي نمرة 1.6 و4 ملم بالسمنت والطريقة',
                'نيشة BS رئيسية وفرعية ستارة ومفتاح حسب الارتفاع والدور واختيار اللون المناسب',
                'أبواب PVC حسب اختيار العميل للشكل',
                'نيشة فايبر مصنع حسب الطلب (العرض خاص بالكتالوجات أو الفرش والرسم)',
                'طقم حمام (قاعدة – بانيو – أحواض – كابينة شاور) من ديورافيت أو إيديال ستاندرد أو تيرو الإيطالي',
                'خلاطات حمام ومطبخ (ديورافيت – إيديال – كلودي) بضمان مدى الحياة',
                'دهانات فاخرة بجميع الألوان حسب اختيار العميل',
                'أرضيات HDF حسب اختيار العميل للشكل واللون',
                'ديكورات حجر حسب الاختيار (العرض خاص بالكتالوجات أو الفرش والرسم)'
            ],
            recommended: false,
            color: '#f1c40f'
        }, // 5000
    ];


    return (
        <section className="pricing-section" id="pricing">
            <div className="container">
                <div className="payment-terms-highlight">
                    <div className="payment-highlight-header">
                        <h3>شطب وانت مرتاح... واستلم على المفتاح 🏠</h3>
                        <p>أنظمة دفع مرنة تناسب الجميع</p>
                    </div>

                    <div className="payment-options-compact">
                        <div className="payment-compact-card">
                            <div className="payment-compact-icon">
                                <i className="fas fa-calendar-alt"></i>
                            </div>
                            <h4>تقسيط على 24 شهر</h4>
                            <p>مقدم 25% - بدون فوائد نهائياً</p>
                        </div>

                        <div className="payment-compact-card">
                            <div className="payment-compact-icon">
                                <i className="fas fa-money-bill-wave"></i>
                            </div>
                            <h4>خصم الكاش 15%</h4>
                            <p>الدفع بيكون علي دفعات مع مراحل التشطيب</p>
                        </div>

                        <div className="payment-compact-card">
                            <div className="payment-compact-icon">
                                <i className="fas fa-search"></i>
                            </div>
                            <h4>معاينة مجانية</h4>
                            <p>للاستعلام: 01111505503</p>
                        </div>
                    </div>
                </div>
                <div className="section-header">
                    <h2>الأسعار</h2>
                    <p>باقات تشطيب تناسب جميع الميزانيات</p>
                </div>

                <div className="pricing-grid">
                    {plans.map(plan => (
                        <Link
                            to="/pricing"
                            className={`pricing-card ${plan.recommended ? 'recommended' : ''}`}
                            key={plan.id}
                            style={{ '--accent-color': plan.color }}
                        >
                            {plan.recommended && (
                                <div className="recommended-badge">
                                    <i className="fas fa-star"></i>
                                    الأكثر طلبًا
                                </div>
                            )}

                            <div className="pricing-header">
                                <h3>{plan.name}</h3>
                                <div className="pricing-price">
                                    <span className="price">{plan.price}</span>
                                    <span className="unit">{plan.unit}</span>
                                </div>
                                <p>{plan.description}</p>
                            </div>

                            <div className="pricing-features">
                                <h4>المميزات الرئيسية</h4>
                                <ul>
                                    {plan.features.slice(0, 5).map((feature, index) => (
                                        <li key={index}>
                                            <i className="fas fa-check"></i>
                                            <span>{feature}</span>
                                        </li>
                                    ))}
                                </ul>

                                {plan.features.length > 5 && (
                                    <div className="more-features">
                                        <i className="fas fa-plus-circle"></i>
                                        <span>+ {plan.features.length - 5} ميزة إضافية</span>
                                    </div>
                                )}
                            </div>

                            <div className="pricing-action">
                                <div className="btn btn-primary">
                                    <span>عرض التفاصيل الكاملة</span>
                                    <i className="fas fa-arrow-left"></i>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="pricing-note">
                    <p>* الأسعار تقريبية وقد تختلف حسب متطلبات المشروع والمواد المستخدمة</p>
                </div>

                <div className="pricing-cta">
                    <h3>احصل على عرض سعر مخصص</h3>
                    <p>املأ البيانات وسنرسل لك عرض سعر تفصيلي عبر الواتساب</p>
                    <Link to="/pricing" className="btn btn-secondary"> اختر الباقة</Link>
                </div>
            </div>
        </section>
    );
};

export default PricingSection;
